import { useDispatch } from 'react-redux';
import { useAppSelector } from 'src/stores';
import { ITenant } from 'src/types/tenant.type';
import { setListTenant, setTenant } from './tenant.slice';

export default function useTenant() {
  const dispatch = useDispatch();
  const { active: tenant, list: listTenant } = useAppSelector((state) => state.tenant) || {
    active: undefined,
    list: [],
  };

  const changeTenant = (tenant?: ITenant) => {
    dispatch(setTenant(tenant));
    if (tenant) {
      localStorage.setItem('tenant_id', tenant.id.toString());
    } else {
      localStorage.removeItem('tenant_id');
    }
  };

  const changeListTenant = (tenants: ITenant[]) => {
    dispatch(setListTenant(tenants));
  };

  return {
    tenant,
    listTenant,
    changeTenant,
    changeListTenant,
  };
}
